<template>
    <div class="audio-file-progress">
        <transition name="fade" mode="out-in">
            <div
                v-if="isUploading"
                key="uploading"
                class="progress-status"
            >
                <span class="upload-percentage">{{ uploadPercentage }}%</span>
                Uploading episode...
            </div>

            <div
                v-else
                key="processing"
                class="progress-status"
            >
                Processing...
            </div>
        </transition>

        <progress-bar :value="uploadPercentage" />

        <button
            type="button"
            class="link-btn"
            @click="$emit('cancel')"
        >
            cancel upload
        </button>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import ProgressBar from '@/components/ProgressBar/ProgressBar';

export default {
    components: {
        ProgressBar,
    },

    computed: {
        ...mapState({
            uploadPercentage: state => state.UIState.addEpisodeModal.uploadPercentage,
        }),

        /**
         * Determines whether file is uploaded or not.
         *
         * @returns {boolean} File is uploaded or not?
         */
        isUploading() {
            return 100 > this.uploadPercentage;
        },
    },
};
</script>
